<template>
  <div class="container">
    <nav class="top-nav">
      <div class="row nav-content">
        <div class="nav-links">
          <router-link
            title="Home"
            class="nav-item"
            :to="'/'"
            :class="{ 'active-nav-bu': $route.path === '/' }"
          >
            {{ $t("Home") }}
          </router-link>
          <router-link
            title="Typing Lessons"
            class="nav-item"
            :to="'/typingLessons'"
            :class="{ 'active-nav-bu': $route.path === '/typingLessons' }"
            style="display: flex; align-items: center;"
          >
            <img src="./assets/icons/classroom-32.png" alt="Lessons" style="width: 24px; height: 24px; margin-right: 5px;">
            <span>{{ $t("Lessons") }}</span>
          </router-link>
          <router-link
            title="Game"
            class="nav-item"
            :to="'/game'"
            :class="{ 'active-nav-bu': $route.path === '/game' }"
            style="display: flex; align-items: center;"
          >
            <img src="./assets/icons/game-32.png" alt="Game" style="width: 24px; height: 24px; margin-right: 5px;">
            <span>{{ $t("Game") }}</span>
          </router-link>
          <router-link
            title="HighScores"
            class="nav-item"
            :to="'/highScores'"
            :class="{ 'active-nav-bu': $route.path === '/highScores' }"
            style="display: flex; align-items: center;"
          >
            <img src="./assets/icons/medal-32.png" alt="High Scores" style="width: 24px; height: 24px; margin-right: 5px;">
            <span>{{ $t("Scores") }}</span>
          </router-link>
          <router-link
            title="About"
            class="nav-item"
            :to="'/about'"
            :class="{ 'active-nav-bu': $route.path === '/about' }"
          >
            {{ $t("About") }}
          </router-link>
        </div>
        <LanguageDropdown
          :langs="langs"
          :languages="languages"
          :flags="flags"
        />
      </div>
    </nav>
    <router-view />
  </div>
</template>

<script>
import LanguageDropdown from './components/Navigation/LanguageDropdown.vue';

export default {
  name: 'KhmerTyping',
  components: { LanguageDropdown },
  data() {
    return {
      version: '0.1.0',
      langs: ['km', 'en', 'jp', 'kr', 'ch'],
      languages: {
        'km': 'ខ្មែរ',
        'en': 'English',
        'jp': 'Japan',
        'kr': 'Korean',
        'ch': 'China',
      },
      flags: {
        'km': require('@/assets/flags/cambodia-32.png'),
        'en': require('@/assets/flags/usa-32.png'),
        'jp': require('@/assets/flags/japan-32.png'),
        'kr': require('@/assets/flags/south-korea-32.png'),
        'ch': require('@/assets/flags/china-32.png'),
      },
    };
  },
};
</script>

<style>
@font-face {
  font-family: "Battambang";
  src: url("../static/fonts/Battambang/Battambang-Regular.ttf") format("truetype");
}

body {
  margin: 0;
  font-family: "Battambang";
  background-color: #f5f5f5;
}

main {
  margin: 2vw;
  max-width: 90vw;
  padding: 0 5vw;
  border-radius: 5px;
  border: solid #e8e8e8 1px;
  text-align: center;
  background-color: #fff;
}

hr {
  border: 0;
  height: 0;
  border-top: 1px solid #e8e8e8;
}

.row {
  display: flex;
  flex-wrap: wrap;
}

h1 {
  color: #3f51b5;
  margin: 2% 0 0 0;
}

h1 + p {
  margin: 0;
}

select {
  margin: 10px;
  height: 30px;
  border: none;
  border-radius: 4px;
  background-color: #ddd;
  font-size: 1em;
}

.top-nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 50px;
  overflow: visible; /* Ensure the dropdown is not clipped */
  background-color: #06c2b3;
  justify-content: space-between;
  z-index: 1000; /* Adjust as needed */
}

.nav-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.custom-dropdown .dropdown-options {
  z-index: 10000; /* Ensure dropdown is above other elements */
}


.nav-links {
  display: flex;
  align-items: center;
}

.nav-item {
  float: left;
  color: #fff;
  text-align: center;
  padding: 11px 16px;
  text-decoration: none;
  font-size: 1em;
}

.nav-item:hover {
  background-color: #ddd;
  color: #3f51b5;
}

.active-nav-bu {
  background-color: #ddd;
  color: #3f51b5;
}
</style>
